import { LogosAndTextProps } from "@made-people/blueprint-logos-and-text";

export const LogosAndText: LogosAndTextProps = {
  template: "template1",
  layout: {
    spacing: {
      y: {
        initial: "xl",
        md: "2xl",
        lg: "3xl",
      },
    },
  },
  variants: {
    layout: {
      initial: "vertical",
      lg: "horizontal",
    },
  },
  heading: {
    variants: {
      headingSize: {
        initial: "lg",
        lg: "xl",
      },
    },
  },
};
